import { authDelete } from "@api";
import { AUTH_URL } from "@constants";
import { AuthType } from "@types";

import { DeleteProviderResponse } from "@pages/settings/types";
export const deleteAuthProvider = (
  deploymentId: string,
  providerType: AuthType
): Promise<DeleteProviderResponse> => {
  const url = `${AUTH_URL}/deployments/${deploymentId}/providers/${providerType}`;
  return authDelete<DeleteProviderResponse>(url);
};
